import { getBinaryImageMetadata } from '../category-api/binary-image-api';
export function isBinaryImage(arrayBuffer, mimeType) {
  var metadata = getBinaryImageMetadata(arrayBuffer);
  if (mimeType) {
    return Boolean(metadata && metadata.mimeType === mimeType);
  }
  return Boolean(metadata);
}
export function getBinaryImageMIMEType(arrayBuffer) {
  var metadata = getBinaryImageMetadata(arrayBuffer);
  return metadata ? metadata.mimeType : null;
}
export function getBinaryImageSize(arrayBuffer) {
  var mimeType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var metadata = getBinaryImageMetadata(arrayBuffer);
  if (metadata) {
    return {
      width: metadata.width,
      height: metadata.height
    };
  }
  mimeType = mimeType || 'unknown';
  throw new Error("invalid image data for type: ".concat(mimeType));
}
//# sourceMappingURL=binary-image-api-deprecated.js.map